import {IntermediatePart} from "../../intermediatePart";

export default class Pendants extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_pendants';
    this.partName = 'Pendants';
    this.translateId = "visualizer.kitchen.center_island.center_island_pendants";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Pendants());
  }
}
